import {Grid, Radio, Typography} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './PaymentCard.classes'
import {Props} from './PaymentCard.types'
import {PaymentSystemIcon} from './PaymentSystemIcon'

export function PaymentCard({card, onPress, checked = false}: Props): React.ReactElement {
  const {system, number, expirationDate} = card

  function clickHandler(card?: Props['card']) {
    if (card && onPress) {
      return function _clickHandler() {
        onPress(card)
      }
    }
  }

  return (
    <Grid
      alignItems="flex-start"
      className={clsx(classes.root, checked && classes.checked, onPress && classes.hovered)}
      data-e2e="payment-card"
      direction="column"
      justify="space-between"
      onPointerUp={clickHandler(card)}
      wrap="wrap"
      container
    >
      <Grid alignItems="center" className={classes.row} justify="space-between" container item xs>
        <Grid item xs>
          <PaymentSystemIcon paymentSystem={system} />
        </Grid>
        <Grid item>
          <Radio checked={checked} className={classes.radio} />
        </Grid>
      </Grid>
      <Grid className={classes.row} direction="column" container item xs>
        <Typography Component={Grid} thickness="light" variant="title4" item>
          {number}
        </Typography>
        {expirationDate && (
          <Grid className={classes.date} item>
            {expirationDate}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
